import _ from 'lodash';
import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Form } from 'react-bootstrap';

import { FormControl } from '../../../facturotopia';

class ReceptorResetPassword extends Component {
  state = {}

  constructor(props) {
    super(props);

    this.state = {
      isTouchedPassword: false,
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    const { isTouchedPassword } = this.state;

    const PasswordRules = ['confirmed', 'min:8', 'password'];
    const PasswordConfirmationRules = ['min:8', 'password'];

    return {
      old_password: !!isTouchedPassword ? ['required'] : [],
      password: !!isTouchedPassword ? ['required'].concat(PasswordRules) : PasswordRules,
      password_confirmation: !!isTouchedPassword ? ['required'].concat(PasswordConfirmationRules) : PasswordConfirmationRules,
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      isValid: validator.passes()
    });

    const isTouched = !_.isEmpty(data.old_password) && !_.isEmpty(data.password) && !_.isEmpty(data.password_confirmation);

    this.setState({
      isTouchedPassword: isTouched
    });
  }

  render() {
    const { data = {} } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="password"
          label="Contraseña actual"
          name="old_password"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.old_password }
          onChange={ this.handleOnChange }
        />

        <FormControl type="password"
          label="Nueva contraseña"
          name="password"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.password }
          onChange={ this.handleOnChange }
        />

        <FormControl type="password"
          label="Confirmar nueva contraseña"
          name="password_confirmation"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.password_confirmation }
          onChange={ this.handleOnChange }
        />

      </Form>
    );
  }
}

export default ReceptorResetPassword;